/* unplugin-vue-components disabled */import { render } from "./CompanionPreference.vue?vue&type=template&id=4c8e072a&scoped=true"
import script from "./CompanionPreference.vue?vue&type=script&lang=js"
export * from "./CompanionPreference.vue?vue&type=script&lang=js"

import "./CompanionPreference.vue?vue&type=style&index=0&id=4c8e072a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8e072a"]])

export default __exports__